import { execSync } from 'child_process'
import { loadConfig, getOrganizationByRepo, getActiveOrganization, getApiUrl } from '../lib/config'

export async function contextCommand(): Promise<void> {
  console.log('\n🔍 Current Context\n')

  // Try to detect current git repository
  const repoInfo: { remote?: string; branch?: string } = {}

  try {
    // Get git remote URL
    const remoteUrl = execSync('git remote get-url origin', {
      encoding: 'utf-8',
      stdio: ['pipe', 'pipe', 'pipe'],
    }).trim()

    // Parse remote URL to get owner/repo
    let repoFullName: string | null = null

    // Handle SSH URLs: git@github.com:owner/repo.git
    const sshMatch = remoteUrl.match(/git@github\.com:([^/]+\/[^/]+?)(?:\.git)?$/)
    if (sshMatch) {
      repoFullName = sshMatch[1]
    }

    // Handle HTTPS URLs: https://github.com/owner/repo.git
    const httpsMatch = remoteUrl.match(/https:\/\/github\.com\/([^/]+\/[^/]+?)(?:\.git)?$/)
    if (httpsMatch) {
      repoFullName = httpsMatch[1]
    }

    if (repoFullName) {
      repoInfo.remote = repoFullName
    }

    // Get current branch
    const branch = execSync('git rev-parse --abbrev-ref HEAD', {
      encoding: 'utf-8',
      stdio: ['pipe', 'pipe', 'pipe'],
    }).trim()
    repoInfo.branch = branch
  } catch {
    // Not in a git repo or git not available
  }

  if (!repoInfo.remote) {
    console.log('📁 Not in a git repository (or no remote configured)')
    console.log('')

    const config = loadConfig()
    const activeOrg = getActiveOrganization()
    if (config.organizations.length > 0) {
      console.log('Organizations:')
      for (const org of config.organizations) {
        const isActive = org.id === activeOrg?.id
        console.log(`  ${isActive ? '●' : '○'} ${org.name}${isActive ? ' (active)' : ''}`)
      }
    } else {
      console.log('No organizations configured. Run: flightdesk init')
    }
    return
  }

  console.log(`📁 Repository: ${repoInfo.remote}`)
  console.log(`🌿 Branch: ${repoInfo.branch}`)
  console.log('')

  // Look up organization mapping
  const mappedOrg = getOrganizationByRepo(repoInfo.remote)
  const activeOrg = getActiveOrganization()

  if (mappedOrg) {
    console.log(`🏢 Organization: ${mappedOrg.name}`)
    console.log(`   API: ${getApiUrl()}`)
    console.log('')
    console.log('This repository is mapped to the above organization.')
    console.log('Commands will use this organization automatically.')
  } else {
    console.log('⚠️  This repository is not mapped to any organization.')
    console.log('')

    const config = loadConfig()
    if (config.organizations.length > 0) {
      console.log('Organizations:')
      for (const org of config.organizations) {
        const isActive = org.id === activeOrg?.id
        console.log(`  ${isActive ? '●' : '○'} ${org.name}${isActive ? ' (active)' : ''}`)
      }
      console.log('')
      console.log('Run: flightdesk sync  to refresh repository mappings')
    } else {
      console.log('No organizations configured. Run: flightdesk init')
    }
  }
}
